import {useMemo} from 'react';
import {useGeneratingScreens} from '@features/ai/streaming/useGeneration';
import {trpc} from '@features/utils/trpc';
import {isComponentScreen} from '@features/flow/utils/componentScreenId';

export function useFlowsScreens(flowId: string) {
  const screens = trpc.screens.getFlowScreens.useQuery({flowId});
  const generatingScreens = useGeneratingScreens(flowId);

  return {
    ...screens,
    data: useMemo(() => {
      if (!screens.data) return screens.data;

      // Only add phantom nodes for component screens (filesystem-based, not in DB).
      // Non-component screens always exist in the database.
      const phantoms = generatingScreens.filter(
        (screen) =>
          isComponentScreen(screen) &&
          screens.data.find((a) => a.id === screen) === undefined,
      );

      // Return original reference when no phantom screens needed
      if (phantoms.length === 0) return screens.data;

      return [
        ...screens.data,
        ...phantoms.map((screen) => ({
          id: screen,
          x: null,
          y: null,
          hasActiveStructure: 'yes' as const,
          screenSize: null,
          themeId: null,
          type: 'screen' as const,
        })),
      ];
    }, [screens.data, generatingScreens]),
  };
}
